var React = require('react');

function QuoteRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-quote-right","data-name":"Icon awesome-quote-right","d":"M181.25,2.25h-50A18.755,18.755,0,0,0,112.5,21V71a18.755,18.755,0,0,0,18.75,18.75H162.5v25a25.023,25.023,0,0,1-25,25h-3.125A9.353,9.353,0,0,0,125,149.125v18.75a9.353,9.353,0,0,0,9.375,9.375H137.5a62.483,62.483,0,0,0,62.5-62.5V21A18.755,18.755,0,0,0,181.25,2.25Zm-112.5,0h-50A18.755,18.755,0,0,0,0,21V71A18.755,18.755,0,0,0,18.75,89.75H50v25a25.023,25.023,0,0,1-25,25H21.875a9.353,9.353,0,0,0-9.375,9.375v18.75a9.353,9.353,0,0,0,9.375,9.375H25a62.483,62.483,0,0,0,62.5-62.5V21A18.755,18.755,0,0,0,68.75,2.25Z","transform":"translate(0 -2.25)","fill":"rgba(0,0,0,0.05)"}));
}

QuoteRight.defaultProps = {"width":"200","height":"175","viewBox":"0 0 200 175"};

module.exports = QuoteRight;

QuoteRight.default = QuoteRight;
